export default "__VITE_ASSET__Bh$goG1o__"